import { fg } from '@atlaskit/platform-feature-flags/fg';
import { IdentityUserAri } from '@atlassian/ari/identity';
import type { AgentAttribution, AgentInfo } from '@atlassian/editor-plugin-ai/types';
import { isAgentType } from '@atlassian/rovo-content-bridge-api-commands/commands/agent-type';

type AgentUpdateIdentity = {
	agentId?: string | null;
	agentIdentityAccountId?: string | null;
	agentName?: string | null;
	agentNamedId?: string | null;
	agentType?: unknown;
	isThirdParty?: boolean;
};

const resolveAgentId = (agentIdentityAccountId: string): string | undefined => {
	if (!agentIdentityAccountId.startsWith('ari:')) {
		return agentIdentityAccountId;
	}

	try {
		return IdentityUserAri.parse(agentIdentityAccountId).userId;
	} catch {
		return undefined;
	}
};

export const getAgentAttribution = ({
	agentType,
	agentId,
	agentIdentityAccountId,
	agentName,
	agentNamedId,
	isThirdParty,
}: AgentUpdateIdentity): AgentAttribution | undefined => {
	if (!fg('platform_editor_agentic_step_attribution')) {
		return undefined;
	}

	return {
		agentId: agentIdentityAccountId ? resolveAgentId(agentIdentityAccountId) : undefined,
		agentName: agentName ?? undefined,
		agentNamedId: agentNamedId ?? undefined,
		agentSourceId: agentId ?? undefined,
		agentType: isAgentType(agentType) ? agentType : 'unknown',
		isThirdParty,
	};
};

export const getAgentUpdateMetadata = (
	identity: AgentUpdateIdentity,
): {
	agentInfo: AgentInfo | undefined;
	// eslint-disable-next-line perfectionist/sort-object-types -- Please migrate this return type to the repository's preferred field order.
	agentAttribution: AgentAttribution | undefined;
} => ({
	agentInfo:
		identity.agentName !== undefined
			? {
					agentId: identity.agentId ?? undefined,
					agentIdentityAccountId: identity.agentIdentityAccountId ?? undefined,
					agentName: identity.agentName ?? undefined,
					agentNamedId: identity.agentNamedId ?? undefined,
					isThirdParty: identity.isThirdParty,
				}
			: undefined,
	agentAttribution: getAgentAttribution(identity),
});
